import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { API_URL } from '../env'
import '../styles/Home.css'
import { Fade, Zoom } from 'react-awesome-reveal'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faComments, faEnvelope, faHandshake, faHouse, faPhone, faStopwatch, faUser } from '@fortawesome/free-solid-svg-icons'
import InputText from './Input/InputText'
import InputSwitch from './Input/InputSwitch'
import Button from './Utils/Button'
import homeSection1 from '../assets/home/home-section1.png'
import homeSection2 from '../assets/home/home-section2.gif'
import homeSection4 from '../assets/home/home-section4.png'
import homeSection5_1 from '../assets/home/home-section5-1.png'
import homeSection5_2 from '../assets/home/home-section5-2.png'
import { BrowserView, MobileView } from 'react-device-detect'
import { toast } from 'react-toastify'
import { ThreeCircles } from 'react-loader-spinner'
import axios from 'axios'
import { Helmet } from 'react-helmet'

function Home({ ip }) {

    const [isLoading, setIsLoading] = useState(false)
    const nameRef = useRef(null)
    const [name, setName] = useState("")
    const [nameError, setNameError] = useState(null)
    const phoneRef = useRef(null)
    const [phone, setPhone] = useState("")
    const [phoneError, setPhoneError] = useState(null)
    const [accept, setAccept] = useState(false)

    function sendContactPhone() {

        setIsLoading(true)
        var error = []
        if (!nameRef.current.nameValidation(name)) {
            error.push("Le nom est incorrect")
        }
        if (!phoneRef.current.phoneValidationOnBlur(phone)) {
            error.push("Le téléphone est incorrect")
        }
        const typeFormat = "Phone"
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Envois...")
            axios.post(API_URL + "contact", {
                type: typeFormat,
                name: name,
                phone: phone,
                ip: ip
            }).then((response) => {
                if (response.data === "CONTACT_SEND") {
                    toast.update(toastId, { render: "Demande de rappel envoyée", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    setName("")
                    setNameError(null)
                    setPhone("")
                    setPhoneError(null)
                    setAccept(false)
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_CONTACT_CREATION" || errorMessage === "ERROR_UPDATE_CONTACT") {
                        errorMessage = "Erreur lors de la création du message"
                    } else if (errorMessage === "ERROR_SENDING_EMAIL") {
                        errorMessage = "Erreur lors de l'envoi du message"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    return (

        <>
            <Helmet>
                <meta name="title" content="Accueil - E5M Diagnostics" />
                <meta name="description" content="Diagnostics et Expertises Immobiliers sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers. Amiante, Plomb, Termite, Gaz, Électricité, DPE, Loi Carrez, Loi Boutin, ERP, Audit Énergétique, Accessibilité, Plan 2D, Plan 3D" />
                <meta property="og:title" content="Accueil - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostics et Expertises Immobiliers sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers. Amiante, Plomb, Termite, Gaz, Électricité, DPE, Loi Carrez, Loi Boutin, ERP, Audit Énergétique, Accessibilité, Plan 2D, Plan 3D" />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr" />
            </Helmet>

            <BrowserView>
                <div id='home'>
                    <div id='homeHeader'>
                        <div id='homeHeaderBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='homeHeaderReminder'>
                                    <h1 id='homeHeaderReminderTitle'>E5M Diagnostics</h1>
                                    <div className='homeHeaderReminderContact'>
                                        <FontAwesomeIcon icon={faPhone} className='homeHeaderReminderContactIcon' />
                                        06 58 80 21 34
                                    </div>
                                    <div className='homeHeaderReminderContact'>
                                        <FontAwesomeIcon icon={faEnvelope} className='homeHeaderReminderContactIcon' />
                                        contact@e5mdiagnostics.fr
                                    </div>
                                    <div className='homeHeaderReminderContact'>
                                        <FontAwesomeIcon icon={faHouse} className='homeHeaderReminderContactIcon' />
                                        4 rue Pierre Brossolette, 92700 Colombes
                                    </div>
                                    <div id='homeHeaderReminderForm'>
                                        <Row>
                                            <Col>
                                                <InputText
                                                    type={'name'}
                                                    theme={'light'}
                                                    ref={nameRef}
                                                    text={name} setText={setName}
                                                    textError={nameError} setTextError={setNameError}
                                                    icon={<FontAwesomeIcon icon={faUser} />}
                                                    placeholder={"Nom"}
                                                    maxLength={64}
                                                    onPressEnter={() => phoneRef.current.inputTextRef.current.focus()}
                                                />
                                            </Col>
                                            <Col>
                                                <InputText
                                                    type={'phone'}
                                                    theme={'light'}
                                                    ref={phoneRef}
                                                    text={phone} setText={setPhone}
                                                    textError={phoneError} setTextError={setPhoneError}
                                                    icon={<FontAwesomeIcon icon={faPhone} />}
                                                    placeholder={"Téléphone"}
                                                    maxLength={14}
                                                    onPressEnter={() => setAccept(true)}
                                                />
                                            </Col>
                                        </Row>
                                        <InputSwitch
                                            theme={'light'}
                                            value={accept} setValue={setAccept}
                                            label={"En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation professionnelle confidentielle."}
                                        />
                                        <div id='homeHeaderReminderFormButton'>
                                            {!isLoading ?
                                                <Button theme={'light'} icon={<FontAwesomeIcon icon={faBell} />} text={"Demande de rappel"} rounded={true} disabled={!accept} onClick={() => sendContactPhone()} />
                                                :
                                                <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderLight')} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                            <Row id='homeHeaderCards'>
                                <Col>
                                    <Zoom duration={500} delay={200}>
                                        <div className='homeHeaderCard'>
                                            <FontAwesomeIcon icon={faStopwatch} className='homeHeaderCardIcon' />
                                            Réactivité
                                        </div>
                                    </Zoom>
                                </Col>
                                <Col>
                                    <Zoom duration={500} delay={300}>
                                        <div className='homeHeaderCard'>
                                            <FontAwesomeIcon icon={faComments} className='homeHeaderCardIcon' />
                                            Disponibilité
                                        </div>
                                    </Zoom>
                                </Col>
                                <Col>
                                    <Zoom duration={500} delay={400}>
                                        <div className='homeHeaderCard'>
                                            <FontAwesomeIcon icon={faHandshake} className='homeHeaderCardIcon' />
                                            Expertise et conseil
                                        </div>
                                    </Zoom>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Row id='homeSection1'>
                        <Col sm={6}>
                            <Fade direction={'left'} duration={500}>
                                <div id='homeSection1Left'>
                                    <h1 className='sectionTitle'>Qui sommes nous ?</h1>
                                    <div className='sectionText'>
                                        La société E5M Diagnostics est spécialisée dans les Diagnostics et Expertises Immobiliers lors de la vente ou de la mise en location de vos biens Immobiliers.
                                    </div>
                                    <div className='sectionText'>
                                        Nous réalisons tous les diagnostics immobiliers, les audits énergétiques, les contrôles immobiliers auxquels sont soumis les logements ou bâtiments professionnels et les repérages avant travaux ou démolition.
                                    </div>
                                    <div className='sectionText'>
                                        Les diagnostics et contrôles immobiliers résultent de textes législatifs et réglementaires de plus en plus rigoureux et qui ne cessent d’évoluer, à l’instar du secteur du bâtiment,
                                        soumis à des contraintes qui se renforcent de plus en plus, liées à la santé et à la sécurité des personnes.
                                    </div>
                                    <div id='homeSection1LeftButton'>
                                        <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">06 58 80 21 34</Link>} />
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='homeSection1Right'>
                                    <img src={homeSection1} id='homeSection1Image' alt='home-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='homeSection2'>
                        <Col sm={6}>
                            <div id='homeSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={homeSection2} id='homeSection2Image' alt='home-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='homeSection2Right'>
                                    <h1 className='sectionTitle'>Expert en Diagnostics Immobiliers pour la Vente d'un Bien</h1>
                                    <div className='sectionText'>
                                        La vente d’un bien immobilier est un processus qui requiert rigueur et transparence. Nous comprenons l’importance de fournir des diagnostics immobiliers précis et fiables pour sécuriser votre transaction
                                        et valoriser votre propriété. Forts de notre expertise et de notre engagement envers la qualité, nous vous proposons un accompagnement sur-mesure dans la réalisation des diagnostics nécessaires à la vente de votre bien.
                                    </div>
                                    <div id='homeSection1LeftButton'>
                                        <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">06 58 80 21 34</Link>} />
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='homeSection3'>
                        <div id='homeSection3TopFilter'>
                            <div id='homeSection3Top'></div>
                        </div>
                        <div id='homeSection3TopTitle'>Quels sont les diagnostics immobiliers obligatoires ?</div>
                        <div id='homeSection3TopSubtitle'>Pour la vente et la location</div>
                        <div id='homeSection3Bottom'>
                            <div id='homeSection3BottomTitle'>Comparatif des diagnostics immobiliers obligatoires : vente et location</div>
                            <div id='homeSection3BottomSubtitle'>
                                Tous les diagnostics obligatoires lors de la mise en location ou à la vente d’un bien.
                            </div>
                        </div>
                    </div>
                    <Row id='homeSection4'>
                        <Col sm={6}>
                            <div id='homeSection4Left'>
                                <Fade direction={'left'} duration={500}>
                                    <h1 className='sectionTitle'>Assurez la Sécurité et la Conformité de Votre Bien en Location</h1>
                                    <div className='sectionText'>
                                        Mettre un bien immobilier en location requiert une attention particulière aux normes de sécurité et de performance énergétique. Avec E5M Diagnostic, bénéficiez d’un service professionnel
                                        et personnalisé pour réaliser tous les diagnostics immobiliers nécessaires à la mise en location de votre propriété. Notre expertise garantit non seulement la conformité de votre bien avec
                                        la législation en vigueur, mais aussi la sécurité et le bien-être de vos futurs locataires.
                                    </div>
                                    <div id='homeSection1LeftButton'>
                                        <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">06 58 80 21 34</Link>} />
                                    </div>
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='homeSection4Right'>
                                    <img src={homeSection4} id='homeSection4Image' alt='home-section4' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='homeSection5'>
                        <h1 className='sectionTitle'>Certifications & Assurance</h1>
                        <Row id='homeSection5Logo'>
                            <Col>
                                <Zoom duration={500}>
                                    <img src={homeSection5_1} className='homeSection5Image' alt='home-section5-1' />
                                </Zoom>
                            </Col>
                            <Col>
                                <Zoom duration={500} delay={100}>
                                    <img src={homeSection5_2} className='homeSection5Image' alt='home-section5-2' />
                                </Zoom>
                            </Col>
                        </Row>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='home'>
                    <div id='homeHeaderMobile'>
                        <div id='homeHeaderBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='homeHeaderReminderMobile'>
                                    <h1 id='homeHeaderReminderTitleMobile'>E5M Diagnostics</h1>
                                    <div className='homeHeaderReminderContactMobile'>
                                        <FontAwesomeIcon icon={faPhone} className='homeHeaderReminderContactIcon' />
                                        06 58 80 21 34
                                    </div>
                                    <div className='homeHeaderReminderContactMobile'>
                                        <FontAwesomeIcon icon={faEnvelope} className='homeHeaderReminderContactIcon' />
                                        contact@e5mdiagnostics.fr
                                    </div>
                                    <div className='homeHeaderReminderContactMobile'>
                                        <FontAwesomeIcon icon={faHouse} className='homeHeaderReminderContactIcon' />
                                        4 rue Pierre Brossolette, 92700 Colombes
                                    </div>
                                    <div id='homeHeaderReminderForm'>
                                        <Row>
                                            <Col>
                                                <InputText
                                                    type={'name'}
                                                    theme={'light'}
                                                    ref={nameRef}
                                                    text={name} setText={setName}
                                                    textError={nameError} setTextError={setNameError}
                                                    icon={<FontAwesomeIcon icon={faUser} />}
                                                    placeholder={"Nom"}
                                                    maxLength={64}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <InputText
                                                    type={'phone'}
                                                    theme={'light'}
                                                    ref={phoneRef}
                                                    text={phone} setText={setPhone}
                                                    textError={phoneError} setTextError={setPhoneError}
                                                    icon={<FontAwesomeIcon icon={faPhone} />}
                                                    placeholder={"Téléphone"}
                                                    maxLength={14}
                                                />
                                            </Col>
                                        </Row>
                                        <InputSwitch
                                            theme={'light'}
                                            value={accept} setValue={setAccept}
                                            label={"En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la relation professionnelle confidentielle."}
                                        />
                                        <div id='homeHeaderReminderFormButton'>
                                            {!isLoading ?
                                                <Button theme={'light'} icon={<FontAwesomeIcon icon={faBell} />} text={"Demande de rappel"} rounded={true} disabled={!accept} onClick={() => sendContactPhone()} />
                                                :
                                                <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderLight')} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Fade>
                            <div id='homeHeaderCardsMobile'>
                                <Zoom duration={500}>
                                    <div className='homeHeaderCardMobile'>
                                        <FontAwesomeIcon icon={faStopwatch} className='homeHeaderCardIcon' />
                                        Réactivité
                                    </div>
                                </Zoom>
                                <Zoom duration={500}>
                                    <div className='homeHeaderCardMobile'>
                                        <FontAwesomeIcon icon={faComments} className='homeHeaderCardIcon' />
                                        Disponibilité
                                    </div>
                                </Zoom>
                                <Zoom duration={500}>
                                    <div className='homeHeaderCardMobile'>
                                        <FontAwesomeIcon icon={faHandshake} className='homeHeaderCardIcon' />
                                        Expertise et conseil
                                    </div>
                                </Zoom>
                            </div>
                        </div>
                    </div>
                    <div id='homeSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Qui sommes nous ?</h1>
                            <div className='sectionTextMobile'>
                                La société E5M Diagnostics est spécialisée dans les Diagnostics et Expertises Immobiliers lors de la vente ou de la mise en location de vos biens Immobiliers.
                            </div>
                            <div className='sectionTextMobile'>
                                Nous réalisons tous les diagnostics immobiliers, les audits énergétiques, les contrôles immobiliers auxquels sont soumis les logements ou bâtiments professionnels et les repérages avant travaux ou démolition.
                            </div>
                            <div className='sectionTextMobile'>
                                Les diagnostics et contrôles immobiliers résultent de textes législatifs et réglementaires de plus en plus rigoureux et qui ne cessent d’évoluer, à l’instar du secteur du bâtiment,
                                soumis à des contraintes qui se renforcent de plus en plus, liées à la santé et à la sécurité des personnes.
                            </div>
                            <div className='homeButtonMobile'>
                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">06 58 80 21 34</Link>} />
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={homeSection1} id='homeSection1ImageMobile' alt='home-section1' />
                        </Fade>
                    </div>
                    <div id='homeSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={homeSection2} id='homeSection2ImageMobile' alt='home-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Expert en Diagnostics Immobiliers pour la Vente d'un Bien</h1>
                            <div className='sectionTextMobile'>
                                La vente d’un bien immobilier est un processus qui requiert rigueur et transparence. Nous comprenons l’importance de fournir des diagnostics immobiliers précis et fiables pour sécuriser votre transaction
                                et valoriser votre propriété. Forts de notre expertise et de notre engagement envers la qualité, nous vous proposons un accompagnement sur-mesure dans la réalisation des diagnostics nécessaires à la vente de votre bien.
                            </div>
                            <div className='homeButtonMobile'>
                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">06 58 80 21 34</Link>} />
                            </div>
                        </Fade>
                    </div>
                    <div id='homeSection3Mobile'>
                        <div id='homeSection3TopFilter'>
                            <div id='homeSection3TopMobile'></div>
                        </div>
                        <div id='homeSection3TopTitleMobile'>Quels sont les diagnostics immobiliers obligatoires ?</div>
                        <div id='homeSection3TopSubtitle'>Pour la vente et la location</div>
                        <div id='homeSection3BottomMobile'>
                            <div id='homeSection3BottomTitle'>Comparatif des diagnostics immobiliers obligatoires : vente et location</div>
                            <div id='homeSection3BottomSubtitle'>
                                Tous les diagnostics obligatoires lors de la mise en location ou à la vente d’un bien.
                            </div>
                        </div>
                    </div>
                    <div id='homeSection4Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Assurez la Sécurité et la Conformité de Votre Bien en Location</h1>
                            <div className='sectionTextMobile'>
                                Mettre un bien immobilier en location requiert une attention particulière aux normes de sécurité et de performance énergétique. Avec E5M Diagnostic, bénéficiez d’un service professionnel
                                et personnalisé pour réaliser tous les diagnostics immobiliers nécessaires à la mise en location de votre propriété. Notre expertise garantit non seulement la conformité de votre bien avec
                                la législation en vigueur, mais aussi la sécurité et le bien-être de vos futurs locataires.
                            </div>
                            <div className='homeButtonMobile'>
                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPhone} />} text={<Link to="tel:0658802134">06 58 80 21 34</Link>} />
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={homeSection4} id='homeSection4ImageMobile' alt='home-section4' />
                        </Fade>
                    </div>
                    <div id='homeSection5Mobile'>
                        <h1 className='sectionTitleMobile'>Certifications & Assurance</h1>
                        <Zoom duration={500}>
                            <img src={homeSection5_1} className='homeSection5ImageMobile' alt='home-section5-1' />
                        </Zoom>
                        <Zoom duration={500} delay={100}>
                            <img src={homeSection5_2} className='homeSection5ImageMobile' alt='home-section5-2' />
                        </Zoom>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default Home
